import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCbSJvTx6n_NTFCBWd-2gHNKPcUwGt5ihE",

  authDomain: "cybersecurity-eea46.firebaseapp.com",

  projectId: "cybersecurity-eea46",

  storageBucket: "cybersecurity-eea46.appspot.com",

  messagingSenderId: "465367677521",

  appId: "1:465367677521:web:c68326fe03bb7e21d15670",

  measurementId: "G-373SQJ3B21",
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

export { auth, db, storage };
